import { getFirebaseFunctionDefinition } from "../../utils/getFirebaseFunctionDefinition";
import { UpdateTenderRequestStruct } from "../types/UpdateTenderRequest";

export const updateTenderDefinition = getFirebaseFunctionDefinition({
  path: "/tenders/update",
  reqType: UpdateTenderRequestStruct,
});
